/** Canonical student sex values (API/DB). */
export const STUDENT_SEX_VALUES = ["male", "female"];

/** i18n keys for sex labels (students.modals.sex.*). */
export const STUDENT_SEX_LABEL_KEYS = {
  male: "students.modals.sex.male",
  female: "students.modals.sex.female",
};

/** Select options: stable API value + i18n label key. */
export const STUDENT_SEX_OPTIONS = [
  { value: "male", labelKey: STUDENT_SEX_LABEL_KEYS.male },
  { value: "female", labelKey: STUDENT_SEX_LABEL_KEYS.female },
];
